export const getCookie = (name) => {
    const match = document.cookie.match(
        RegExp(
            '(?:^|;\\s*)' +
                name.replace(/([.*+?^$(){}|[\]\\])/g, '\\$1') +
                '=([^;]*)'
        )
    );
    return match ? match[1] : null;
};

export const redirectToLogin = () => {
    const nextUrl = encodeURIComponent(
        `${window.location.pathname}${window.location.search}`
    );
    window.location.href = `/wt/oidc/authenticate/?next=${nextUrl}`;
};

const getSafeRefreshUrl = (refreshUrl) => {
    if (!refreshUrl) {
        return null;
    }

    const parsed = new URL(refreshUrl, window.location.origin);
    if (parsed.origin !== window.location.origin) {
        throw new Error('Auth refresh_url must be same-origin');
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
};

export const fetchWithAuth = async (url, options = {}) => {
    const { headers: optionHeaders = {}, ...restOptions } = options;
    const headers = {
        'X-CSRFToken': getCookie('csrftoken'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...optionHeaders,
    };

    const response = await fetch(url, {
        credentials: 'same-origin',
        redirect: 'manual',
        ...restOptions,
        headers,
    });

    if (
        response.type === 'opaqueredirect' ||
        response.status === 401 ||
        response.status === 302
    ) {
        redirectToLogin();
        return null;
    }

    if (response.status === 403) {
        let refreshUrl = response.headers.get('refresh_url');
        if (!refreshUrl) {
            const body = await response.json();
            refreshUrl = body?.refresh_url;
        }
        if (refreshUrl) {
            const safeRefreshUrl = getSafeRefreshUrl(refreshUrl);
            if (!safeRefreshUrl) {
                throw new Error('Auth refresh response missing refresh_url');
            }
            window.location.href = safeRefreshUrl;
            return null;
        }
        throw new Error('Auth refresh response missing refresh_url');
    }

    return response;
};

export const fetcherWithAuth = async (url) => {
    const response = await fetchWithAuth(url);
    if (!response) throw new Error('Authentication required');
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.detail || `Request failed: ${response.status}`);
    }
    return response.json();
};
